import { Mail, ArrowRight, Clock3, Package } from "lucide-react";
import { CONTACT_EMAIL } from "../data";
import { Breadcrumb } from "../Layout";

const sujets = [
  {
    icon: Package,
    title: "Références & disponibilité",
    text: "Un gel, une teinte, un embout précis ? Demandez-nous les références en stock et les tarifs en cours.",
  },
  {
    icon: Clock3,
    title: "Conseil d'application",
    text: "Temps de catalysation, choix d'une base, vitesse de ponceuse : nous vous répondons avec le protocole adapté.",
  },
];

export default function Contact() {
  return (
    <div className="mx-auto max-w-6xl px-4 py-14 sm:px-8">
      <Breadcrumb items={[{ label: "Accueil", to: "/" }, { label: "Contact" }]} />
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
        <div className="lg:col-span-6">
          <p className="tag-mono mb-4 text-[#E4C5B3]">Contact</p>
          <h1 className="font-display text-4xl font-medium leading-[1.1] tracking-tight sm:text-5xl">
            Écrivez-nous, nous répondons personnellement
          </h1>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-zinc-400 sm:text-lg">
            AB Nails est une boutique en ligne : toutes les demandes — commandes, prix, conseils produits —
            passent par e-mail. C'est le moyen le plus sûr d'obtenir une réponse précise et documentée.
          </p>
          <a href={`mailto:${CONTACT_EMAIL}`} data-testid="contact-email-cta" className="btn-primary mt-8">
            <Mail size={16} aria-hidden="true" /> {CONTACT_EMAIL}
          </a>
          <p className="mt-6 text-sm text-zinc-500">
            Boutique en ligne — France. AB Nails ne dispose pas de salon physique.
          </p>
        </div>
        <div className="space-y-5 lg:col-span-6">
          {sujets.map((s) => (
            <div key={s.title} className="border border-white/10 bg-[#15151C] p-7">
              <s.icon size={22} className="text-[#D4AF37]" aria-hidden="true" />
              <h2 className="mt-4 font-display text-xl font-medium">{s.title}</h2>
              <p className="mt-2 text-sm leading-relaxed text-zinc-400 sm:text-base">{s.text}</p>
            </div>
          ))}
          <div className="border border-[#E4C5B3]/25 bg-[#1C1C26] p-7">
            <h2 className="font-display text-xl font-medium">Avant d'écrire</h2>
            <p className="mt-2 text-sm leading-relaxed text-zinc-400 sm:text-base">
              Les réponses aux questions les plus fréquentes — catalysation, fraises, marques — sont déjà en ligne.
            </p>
            <a href="/faq/" data-testid="contact-faq-link" className="link-arrow mt-4 inline-flex">
              Consulter la FAQ <ArrowRight size={16} aria-hidden="true" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
